import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Landmark } from '../../../../database/models';
import ImperialPipe from '../../../../utils/pipes/imperial.pipe';
import { LandmarkIconComponent } from './landmark-icon/landmark-icon.component';

@Component({
  selector: 'landmark-card',

  imports: [LandmarkIconComponent, ImperialPipe, MatIconModule],
  templateUrl: './landmark-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './landmark-card.component.scss',
})
export class LandmarkCardComponent {
  public landmark = input.required<Landmark>();
  public distanceData = input<{ distance: number; prefix: string }>(null);
  public isDisplayDevices = input<boolean>(false);
}
